import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  /** Причина блокировки — показывается рядом. Заблокированная кнопка без причины — баг (правило 3). */
  reason?: ReactNode;
};

// A0: mono, radius 4, border 1px. У кнопки цвет задан явно всегда —
// иначе текст наследует системный чёрный и пропадает в тёмной теме.
const variants: Record<Variant, string> = {
  primary: "border-acc bg-acc text-accink font-medium hover:brightness-[1.08]",
  secondary: "border-bd2 bg-transparent text-ink hover:border-acc hover:text-acc",
  ghost: "border-transparent bg-transparent text-ink2 hover:bg-card2",
  danger: "border-err bg-transparent text-err hover:bg-errsoft",
};
const sizes: Record<Size, string> = {
  sm: "px-[11px] py-[6px] text-[11px]",
  md: "px-4 py-[9px] text-[13px]",
  lg: "px-5 py-3 text-[14px] font-medium",
};

export function Button({ variant = "secondary", size = "md", reason, disabled, className = "", children, ...rest }: ButtonProps) {
  const base = "inline-flex items-center gap-2 rounded-sm border font-mono leading-none cursor-pointer transition-colors";
  const look = disabled ? "border-dashed border-bd bg-transparent text-mut cursor-not-allowed" : variants[variant];
  const button = (
    <button type="button" disabled={disabled} className={`${base} ${sizes[size]} ${look} ${className}`} {...rest}>
      {children}
    </button>
  );
  if (!reason) return button;
  return (
    <span className="inline-flex items-center gap-2.5">
      {button}
      <span className="font-mono text-[11px] text-mut">{reason}</span>
    </span>
  );
}
